import { Injectable, Inject } from '@angular/core';
import { RouterStateSnapshot, CanActivate } from '@angular/router';
import { ActivatedRouteSnapshot } from '@angular/router';
import { RoutingService } from '@app/core/services/routing.service';
import { environment } from '@env/environment';

@Injectable()
export class ExternalLinkResolver implements CanActivate {
  private activated: boolean;
  private allowedFrom: Array<string> = ['dev', 'stage'];
  private environment: string = environment.envName;

  constructor(private routingService: RoutingService, @Inject('HOST') private hostname: string) {
    this.activated = this.allowedFrom.indexOf(this.environment) > -1;

    // Force allowed for non-production hostnames
    if (this.hostname.split('.').length !== 3) {
      this.activated = true;
    }
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (route.routeConfig.path === '**') {
      this.activated = false;
    }

    if (!this.activated) {
      this.routingService.failover(state.url);
    }

    return this.activated;
  }
}
